function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.99516 5.70195C7.76876 5.70195 9.19749 4.42147 9.19749 2.8455C9.19749 1.26953 7.76876 0 5.99516 0C4.22156 0 2.78051 1.28048 2.78051 2.8455C2.78051 4.41053 4.22156 5.70195 5.99516 5.70195ZM5.99516 0.744208C7.30072 0.744208 8.35996 1.68541 8.35996 2.8455C8.35996 4.00559 7.30072 4.9468 5.99516 4.9468C4.68959 4.9468 3.63036 4.00559 3.63036 2.8455C3.63036 1.68541 4.68959 0.744208 5.99516 0.744208Z",
  fill: "#9CA0AA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.427998 10.1562H11.5869C11.8209 10.1562 12.0057 9.99209 12.0057 9.78415C12.0057 7.81418 10.2074 6.20538 7.97811 6.20538H4.03678C1.81978 6.19443 0.00923157 7.80324 0.00923157 9.78415C0.00923157 9.99209 0.193981 10.1562 0.427998 10.1562ZM4.03678 6.94959H7.97811C10.2639 6.94959 9.07272 9.4011 6.78689 9.4011H5.22546C2.94192 9.4011 1.75324 6.94959 4.03678 6.94959Z",
  fill: "#9CA0AA"
});

var SvgParticipants = function SvgParticipants(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParticipants, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/participants.7007be79.svg";
export { ForwardRef as ReactComponent };